export const VIEW_MAPS_POLYLINE = 1;
export const VIEW_MAPS_MARKERS = 2;